import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
    selector: 'app-modal-commentaire',
    templateUrl: './modal-commentaire.component.html',
    styleUrls: ['./modal-commentaire.component.scss'],
    standalone: false
})
export class ModalCommentaireComponent implements OnInit {

  genericAppt;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams
  ) {
    const mission = this.navParams.get('mission');
    this.genericAppt = mission.constat.genericAppointment;
   }

  ngOnInit() {}

  close() {
    this.modalCtrl.dismiss();
  }
}
